import styled from 'styled-components'

const EventsStyle = styled.div.attrs()`
	.btn {
		font-size: var(--sp3x);
	}
	&.active {
		.main-event {
			.imageCont {
				clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
			}
		}
	}

	.back-btn {
		display: flex;
		align-items: center;
		margin: var(--sp6x) 0 var(--sp13x);

		i {
			font-size: var(--sp8x);
			transform: rotate(180deg);
			margin-right: var(--sp4x);
		}
	}

	.main-event {
		align-items: flex-start;

		.left {
			max-width: var(--sp123x);

			.date {
				max-width: var(--sp40x);
			}

			.category {
				margin: var(--sp7x) 0;
				i {
					animation: starIconAnim 4s linear infinite;
					font-size: var(--sp4-5x);
					margin-right: var(--sp4x);

					@keyframes starIconAnim {
						0% {
							transform: rotate(0deg);
						}
						100% {
							transform: rotate(360deg);
						}
					}
				}
			}

			.desc {
				margin: var(--sp3x) 0 var(--sp7x);
			}

			.options {
				width: 100%;
				border-top: 1px solid var(--textColor);
				padding-top: var(--sp4x);

				.single-option {
					.option-title {
						margin-bottom: var(--sp4x);
					}

					.partners {
						.single-partner {
							text-align: left;

							&:not(:last-child) {
								margin-bottom: var(--sp4x);
							}
						}
					}
				}
			}

			.btn-cont {
				margin: var(--sp9x) 0 var(--sp28x);
			}
		}

		.imageCont {
			width: 39.8%;
			padding-top: 26.3%;
			clip-path: polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%);
			transition: var(--trTime);
		}
	}

	.related-title {
		margin-bottom: var(--sp7x);
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		.btn {
			font-size: var(--sp2-5x);
		}
		.back-btn {
			margin: var(--sp5x) 0 var(--sp10x);

			i {
				font-size: var(--sp7x);
				margin-right: var(--sp3x);
			}
		}

		.main-event {
			.left {
				max-width: var(--sp90x);

				.date {
					max-width: var(--sp35x);
				}

				.category {
					margin: var(--sp6x) 0;
					i {
						font-size: var(--sp5x);
						margin-right: var(--sp3x);
					}
				}

				.desc {
					margin: var(--sp3x) 0 var(--sp6x);
				}

				.options {
					padding-top: var(--sp3x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp3x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp3x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp8x) 0 var(--sp25x);
				}
			}

			.imageCont {
				width: 54%;
				padding-top: 35.6%;
			}
		}

		.related-title {
			margin-bottom: var(--sp6x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		.btn {
			font-size: var(--sp2x);
		}
		.back-btn {
			margin: var(--sp4x) 0 var(--sp9x);

			i {
				font-size: var(--sp6x);
				margin-right: var(--sp3x);
			}
		}

		.main-event {
			.left {
				max-width: var(--sp70x);

				.date {
					max-width: var(--sp27x);
				}

				.category {
					margin: var(--sp5x) 0;
					i {
						font-size: var(--sp3-5x);
						margin-right: var(--sp2-5x);
					}
				}

				.desc {
					margin: var(--sp3x) 0 var(--sp5x);
				}

				.options {
					padding-top: var(--sp3x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp3x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp3x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp7x) 0 var(--sp20x);
				}
			}

			.imageCont {
				width: 53%;
				padding-top: 35%;
			}
		}

		.related-title {
			margin-bottom: var(--sp5x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		.btn {
			font-size: var(--sp2x);
		}
		.back-btn {
			margin: var(--sp4x) 0 var(--sp8x);

			i {
				font-size: var(--sp6x);
				margin-right: var(--sp3x);
			}
		}

		.main-event {
			.left {
				max-width: var(--sp61x);

				.date {
					max-width: var(--sp22x);
				}

				.category {
					margin: var(--sp4x) 0;
					i {
						font-size: var(--sp3-5x);
						margin-right: var(--sp2-5x);
					}
				}

				.desc {
					margin: var(--sp2x) 0 var(--sp4x);
				}

				.options {
					padding-top: var(--sp2x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp2x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp2x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp5x) 0 var(--sp18x);
				}
			}

			.imageCont {
				width: 53%;
				padding-top: 35%;
			}
		}

		.related-title {
			margin-bottom: var(--sp4x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.btn {
			font-size: var(--sp2x);
		}
		.back-btn {
			margin: var(--sp3x) 0 var(--sp7x);

			i {
				font-size: var(--sp5x);
				margin-right: var(--sp3x);
			}
		}

		.main-event {
			.left {
				max-width: var(--sp58x);

				.date {
					max-width: var(--sp18x);
				}

				.category {
					margin: var(--sp3x) 0;
					i {
						font-size: var(--sp3-5x);
						margin-right: var(--sp2x);
					}
				}

				.desc {
					margin: var(--sp2x) 0 var(--sp3x);
				}

				.options {
					padding-top: var(--sp2x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp2x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp2x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp4x) 0 var(--sp15x);
				}
			}

			.imageCont {
				width: 49.5%;
				padding-top: 32.6%;
				margin-left: var(--sp3x);
			}
		}

		.related-title {
			margin-bottom: var(--sp3x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.btn {
			font-size: var(--sp2x);
		}
		.back-btn {
			margin: var(--sp3x) 0 var(--sp7x);

			i {
				font-size: var(--sp5x);
				margin-right: var(--sp3x);
			}
		}

		.main-event {
			flex-direction: column-reverse;

			.left {
				max-width: unset;
				margin-top: var(--sp4x);

				.date {
					max-width: var(--sp18x);
				}

				.category {
					margin: var(--sp3x) 0;
					i {
						font-size: var(--sp3-5x);
						margin-right: var(--sp2x);
					}
				}

				.desc {
					margin: var(--sp2x) 0 var(--sp3x);
				}

				.options {
					padding-top: var(--sp2x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp2x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp2x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp4x) 0 var(--sp15x);
				}
			}

			.imageCont {
				width: 100%;
				padding-top: 65.7%;
			}
		}

		.related-title {
			margin-bottom: var(--sp3x);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.btn {
			font-size: var(--sp1-6x);
		}
		.btn {
			font-size: var(--sp2x);
		}
		.back-btn {
			margin: var(--sp3x) 0 var(--sp6x);

			i {
				font-size: var(--sp5x);
				margin-right: var(--sp2x);
			}
		}

		.main-event {
			flex-direction: column-reverse;

			.left {
				max-width: unset;
				margin-top: var(--sp3x);

				.date {
					max-width: var(--sp18x);
				}

				.category {
					margin: var(--sp3x) 0;
					i {
						font-size: var(--sp3-5x);
						margin-right: var(--sp2x);
					}
				}

				.desc {
					margin: var(--sp2x) 0 var(--sp3x);
				}

				.options {
					padding-top: var(--sp2x);

					.single-option {
						.option-title {
							margin-bottom: var(--sp2x);
						}

						.partners {
							.single-partner {
								&:not(:last-child) {
									margin-bottom: var(--sp2x);
								}
							}
						}
					}
				}

				.btn-cont {
					margin: var(--sp3x) 0 var(--sp12x);
				}
			}

			.imageCont {
				width: 100%;
				padding-top: 66%;
			}
		}

		.related-title {
			margin-bottom: var(--sp3x);
		}
	}
`
export default EventsStyle
